import { ComingSoonPanel, IconAddon } from '@shared/ui';

/**
 * The add-on catalog, seen from one client instead of from the catalog.
 *
 * Not a second feature: `/addons` will define the commercial modules — each one
 * a bundle of feature flags plus entitlement limits — and this tab is the other
 * end of the same relationship, answering which of them this particular tenant
 * has and what that costs it. Building it before the catalog exists would mean
 * inventing the products it is supposed to read.
 */
export function ClientProductsTab() {
    return (
        <ComingSoonPanel
            icon={<IconAddon className="size-6" />}
            title="Product settings"
            blurb="One card per add-on from the /addons catalog, scoped to this client: whether it is active for the tenant, what the module does, and what it costs. It lands with the catalog and the per-tenant subscriptions it reads."
        />
    );
}
